export const USERNAME_PATTERN = /^[a-zA-Z0-9_]{3,20}$/;
export const USERNAME_RULE_MESSAGE =
  'username ต้องมี 3–20 ตัวอักษร (a-z, A-Z, 0-9, _)';

export function sanitizeUsername(value) {
  return value.replace(/[^a-zA-Z0-9_]/g, '');
}

export function isValidUsername(value) {
  return USERNAME_PATTERN.test(value.trim());
}
